import React from "react";
import {Button, Drawer, Form, Input, Select, Spin} from "antd";
import {LaborNameList} from "../../models/crm/labor";

const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;

class LaborName extends React.Component {
    state = {
        visible: false,
        data: [],
        value: [],
        fetching: false
    };
    showDrawer = () => {
        this.setState({
            visible: true
        });
    };
    onClose = () => {
        this.setState({
            visible: false
        });
    };
    handleChange = value => {
        this.setState({
            value,
            fetching: false
        });
        value && this.props.onChange(value.key);
    };

    fetch = (params = {}) => {
        LaborNameList(params)
            .then(response => {
                this.setState({data: response.data.results})
            })
    }

    componentDidMount() {
        if (this.props.onRef)
            this.props.onRef(this)
    }

    componentWillUnmount() {
        if (this.props.onRef)
            this.props.onRef(null)
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const {fetching, data, value} = this.state;
        return (
            <div className="pos-relative">
                <Select mode="default" labelInValue showSearch value={value} placeholder="Select Labor Name"
                        notFoundContent={fetching ? <Spin size="small"/> : null} filterOption={false}
                        onChange={this.handleChange} onFocus={this.fetch} onSearch={this.fetch}
                        style={{width: "100%"}}>
                    {data.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
                </Select>
            </div>
        );
    }
}

export const LaborNameFilter = Form.create()(LaborName);


// WEBPACK FOOTER //
// ./src/filters/crm/LaborName.jsx